import React, {Component} from 'react';

class Help extends Component {
    render() {
        return (<h3 style={{backgroundColor: '#fff'}}>Help</h3>)
    }
}

export default Help;


// WEBPACK FOOTER //
// ./src/components/help/index.js